import React from "react";

import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

const styles = {
  description: {
    fontSize: "0.865rem",
    lineHeight: "normal",
  },
};

/**
 * A component wrapper to display the embedded text with the description style.
 */
const Description = ({ children }) => (
  <Box marginBottom="15px">
    <Typography style={styles.description}>{children}</Typography>
  </Box>
);

Description.propTypes = {
  /**
   * The text/element to embed with the description style.
   */
  children: PropTypes.any.isRequired,
};

export default Description;
